<div class="container">
    <div id="invoice">
      <h1>PROFORMA</h1>

      <div class="row">

        <div class="col-md-6">
            <div style="font-weight: 900;" class="date">
                Fecha de proforma:
                <input [(ngModel)]="fecha_orden" type="date" class="form-control" />
              </div>
        </div>
        <div style="font-weight: 900;" class="col-md-6">
            <div class="date">
                Fecha de Vencimiento:
                <input type="date" [(ngModel)]="fecha_entrega" class="form-control" />
              </div>
        </div>
      </div>
    
     
    </div>
    <div id="details" class="clearfix">
      <div id="client">
  
        <label style="font-weight: 900;" for="producto">Cliente</label>
  
        <ng-select
          bindLabel="name"
          placeholder="Selecionar cliente"
          [searchable]="true"
          (change)="getSelectedOptionText($event)"
          [(ngModel)]="selectedValue"
        >
          <ng-option
            [disabled]="estado"
            [value]="item"
            *ngFor="let item of clientes"
          >
            {{ item.nombres }} {{ item.apellidos }}
          </ng-option>
        </ng-select>
  
        <a
          class="bg-info text-white badge badge-purple badge-outlined"
          style="cursor: pointer;"
          (click)="clienteModal('nose')"
          >Nuevo Cliente
          <i class="fas fa-user-plus text-purple"></i>
        </a>
  
        <div class="address">
          <span *ngIf="selectedValue">
            <br />
            <label style="font-weight:900" >NIT/CI: {{ nit }}</label>
          </span>
        </div>
        <div class="email">
          <span *ngIf="selectedValue">
            <label style="font-weight:900">Direccion: {{ direccion }}</label>
          </span>
        </div>
      </div>
    </div>
  
    <br />
    <form [formGroup]="form" novalidate (ngSubmit)="save(form.value)">
      <div class="cdard-header">
        <i class="fas fa-users text-success"></i> Detalles:
        <a
          class="btn  bg-primary  text-white"
          style="cursor: pointer;"
          (click)="nuevoProducto()"
          >+
          <i class="fas fa-user-plus text-purple"></i>
        </a>
      </div>
      <div formArrayName="credentials">
        <div class="row bg-info text-white">
          <div class="col-1 col-md-1 col-sm-1 p-1 m-0 text-center">
            #
          </div>
          <div class="col-11 col-md-4 col-sm-12 p-1 m-0 text-center">
            DESCRIPCION
          </div>
          <div class=" col-4 col-md-1 col-sm-6 p-1 m-0">
            U.M.
          </div>
          <div class=" col-4 col-md-1 col-sm-6 p-1 m-0">
            CANT.
          </div>
          <div class="col-4 col-md-1 col-sm-6 p-1 m-0">
            STOCK
          </div>
          <div class="col-4 col-md-1 col-sm-6 p-1 m-0">
            PRECIO
          </div>
          <div class="col-6 col-md-1 col-sm-6 p-1 m-0">
            SUBTOTAL
          </div>
          <div class="col-6 col-md-1 col-sm-6 text-right"></div>
        </div>
        <div
          *ngFor="let creds of formData.controls; let i = index"
          [formGroupName]="i"
          class="row m-2"
        >
          <div>
            {{ i + 1 }}
          </div>
  
          <div style="font-size: 13px;" class="col-11 col-md-5 col-sm-11 p-1 m-0">
            <ng-select
              bindLabel="name"
              placeholder="Selecionar Producto"
              [searchable]="true"
              (change)="getSelectedProduct($event, i)"
              formControlName="producto"
            >
              <ng-option
                [disabled]="estado"
                [value]="item"
                *ngFor="let item of products"
              >
              {{item.codigo}}-{{ item.nombre_producto }}
              </ng-option>
            </ng-select>
          </div>
          <div class=" col-4 col-md-1 col-sm-6 p-1 m-0">
            <input
              type="text"
              placeholder="U.M"
              class="form-control"
              formControlName="unidad"
            />
          </div>
          <div class=" col-4 col-md-1 col-sm-6 p-1 m-0">
            <input
              type="number"
              class="form-control"
              formControlName="cantidad"
              placeholder="CANT"
            />
          </div>
          <div class="col-4 col-md-1 col-sm-6 p-1 m-0">
            <input
              type="text"
              placeholder="STOCK"
              class="form-control"
              formControlName="stock"
            />
          </div>
          <div class="col-4 col-md-1 col-sm-6 p-1 m-0">
            <input  [style.background-color]="creds.get('precio').value< creds.get('precio2').value?'red':'white'"
              type="number"
              placeholder="PRECIO"
              class="form-control"
              formControlName="precio"
            />
          </div>
        
          <div class="col-6 col-md-1 col-sm-6 p-1 m-0">
            <input
              type="text"
              class="form-control"
              formControlName="totalUnitPrice"
              placeholder="TOTAL"
            />
          </div>
          <div class="col-6 col-md-1 col-sm-6 text-right">
            <a class="btn btn-danger" (click)="eliminarProducto(i)"> x</a>
          </div>
        </div>
  
        <br />
        <div class="row">
          <div class="col-md-10 text-right ">
            <h4>
              TOTAL: {{ totalSum | currency: 'BOB':'symbol-narrow':'1.2-2' }}
            </h4>
          </div>
        </div>
  
        <hr />
  
        <hr />
  
        <!--
          <table  class="table" border="0" cellspacing="0" cellpadding="0">
            <thead>
              <tr>
                <th class="no">#</th>
                <th colspan="2" class="desc">DESCRIPCION DEL PRODUCTO</th>
                <th></th>
                <th class="unit">CANTIDAD</th>   
                <th class="unit">STOCK</th>
                <th class="unit">PRECIO</th>
                <th class="total">TOTAL</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let creds of formData.controls; let i = index"
                [formGroupName]="i"
              >
                <td class="no">{{ i + 1 }}</td>
                <td style="max-width: 500px;" colspan="3" class="desc">
                  <ng-select
                    bindLabel="name"
                    placeholder="Selecionar Producto"
                    [searchable]="true"
                    (change)="getSelectedProduct($event, i)"
                    formControlName="producto"
                  >
                    <ng-option
                      [disabled]="estado"
                      [value]="item"
                      *ngFor="let item of products"
                    >
                      {{ item.nombre_producto }}
                    </ng-option>
                  </ng-select>
                </td>
                <td style="max-width: 50px;" class="unit">
  
                  
                      <input
                        type="number"
                        class="form-control"
                        formControlName="cantidad"
                      />
                    
                </td>
                <td style="max-width: 50px;">
                    <input
                    type="text"
                    class="form-control"
                    formControlName="stock"
                  />
                </td>
                <td style="max-width: 50px;" class="qty">
                  <input
                    type="number"
                    class="form-control"
                    formControlName="precio"
                  />
                </td>
  
                <td style="max-width: 50px;" class="qty">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="totalUnitPrice"
                  />
                </td>
                <td class="">
                  
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4"></td>
                <td colspan="2">SUBTOTAL</td>
                <td class="text-left">
                  {{ totalSum | currency: 'BOB':'symbol-narrow':'1.2-2' }}
                </td>
              </tr>
            </tfoot>
          </table>
  
  -->
      </div>
      <div class="row">
        <div class="col-md-3">
          Tipo de pago:
          <select formControlName="pago" class="form-control" name="valueCheck">
            <option *ngFor="let obj of cancelacion" [ngValue]="obj.name">
              {{ obj.name }}
            </option>
          </select>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          <button
            class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
            [disabled]="form.invalid || isLoading"
          >
            <app-button-loader
              [isLoading]="isLoading"
              [label]="'Registrar Proforma'"
            ></app-button-loader>
          </button>
        </div>
      </div>
    </form>
  </div>
  